
import Vue from 'vue'

const numberFixed = (val,len) => {
  return !val && val!==0 ? val : Number(val).toFixed(len)
}
const uid = () => Math.random().toString(36).substr(-8)
Vue.prototype.$uid = uid
Vue.filter('numberFixed', numberFixed)
